/* global axios */
import ApiClient from './ApiClient';

// Observability endpoint for the UAZAPI provider (Task 12, custom overlay):
// GET /api/v1/accounts/:account_id/provider_logs, paginated, filterable by
// `status` and `inbox_id`. See
// custom/app/controllers/custom/api/v1/accounts/provider_logs_controller.rb.
class ProviderLogsAPI extends ApiClient {
  constructor() {
    super('provider_logs', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new ProviderLogsAPI();
